import {
    orderClientAndBestContact,
    useClientNameOrder,
} from "components/clients/client-name-order";
import { CrmPersona } from "components/ui/persona";
import React from "react";
import { Link } from "react-router-dom";

interface ClientPersonaLinkProps {
    size?: "small" | "large" | "auto";
    client: {
        appLink: string | null;
        name?: string;
        bestContactName?: string;
    };
}

export const ClientPersonaLink: React.FC<ClientPersonaLinkProps> = props => {
    const { client, size = "large" } = props;
    const stopPropagation: React.MouseEventHandler<HTMLAnchorElement> = React.useCallback(
        (e: React.MouseEvent<HTMLAnchorElement>) => {
            e.stopPropagation();
        },
        [],
    );

    const order = useClientNameOrder();
    const [primaryName, secondaryName] = orderClientAndBestContact({
        order,
        client: client.name || "",
        bestContact: client.bestContactName || "",
    });

    const persona = (
        <div
            className={`flex items-center ${size === "small" ? "space-x-2" : "space-x-4"}`}>
            <div className="flex-shrink-0">
                <CrmPersona size={size} initialsOnly name={client.name} />
            </div>
            <div>
                <div className="text-sm font-medium truncate text-gray-900">
                    {primaryName}
                </div>
                <div className="text-sm truncate text-gray-500">{secondaryName}</div>
            </div>
        </div>
    );

    if (!client.appLink) {
        return persona;
    }

    return (
        <Link onClick={stopPropagation} to={client.appLink}>
            {persona}
        </Link>
    );
};
